import {
  AiOutlineArrowRight,
} from "react-icons/ai";

import { Link } from "react-router-dom";

const OurStores = () => {


  const customerNotice26 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Notice_post_settlement_thumbnail.jpg"
  const customerNotice25 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/1226_IZB_tax_noticve_thumbnail.png"
  const customerNotice24 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/1901_IZB_old_currency_thumbnail.png"
  const customerNotice27 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB-Notice-post-settlement-thumbnail.png"
  const customerNotice28 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB%20Notice%20post%20thumbnail-1.jpg.jpeg"

  return (
    <section>
      <div className="container notice-and-announcements">
        <div className="row">
          <div className="container">
            <div className="heading py-2">
              <h2 className="text-center">Notice / Announcements</h2>
              {/* <p className="text-center">All News And Updates</p> */}
            </div>
            <div
              className="py-4 read-more-flot-btn"
            // style={{ float: "right"}}
            >
              <Link
                to="/NoticeAnnouncements"
                className="text-white rounded px-3 py-1"
                style={{ backgroundColor: "#9E1B1E" }}
              >
                See More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
              </Link>
            </div>
          </div>

          <div className="col-xl-4 col-lg-4">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Newspaper%20Radver%20Post.jpg.jpeg" target="_blank">
                <div className="img-holder">
                  <div className="inner">
                    <img className="imgresize" src={customerNotice28} alt="" />
                    <div className="overlay-icon"></div>
                  </div>
                </div>
              </a>
              <div className="text-holder">
                <h3 className="blog-title">
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Newspaper%20Radver%20Post.jpg.jpeg" target="_blank">
                    SALE OF MOTOR VEHICLES BY TENDER
                  </a><br />
                  <span style={{ fontSize: "15px", color: "gray" }}>March 2, 2026</span>
                </h3>
                <p style={{ marginBottom: "0rem" }}>
                  Indo Zambia Bank invites bids for the sale of vehicles including a 2011 Nissan Hardbody (non-runner) and a 2016 Toyota Corolla (runner). Bids should be submitted to the Head Office by Friday, 13th March 2026 at 15:00 hrs...
                </p>
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Newspaper%20Radver%20Post.jpg.jpeg" target="_blank">
                  <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                  </h5>
                </a>
                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
              </div>
            </div>
          </div>
          {/* ...existing code... */}

          <div className="col-xl-4 col-lg-4">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Notice_post_settlement.jpg" target="_blank">
                <div className="img-holder">
                  <div className="inner">
                    <img className="imgresize" src={customerNotice26} alt="" />

                    <div className="overlay-icon"></div>

                  </div>
                </div>
              </a>

              <div className="text-holder">
                <h3 className="blog-title">

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Notice_post_settlement.jpg" target="_blank">
                    SETTLEMENT OF DOMESTIC TRANSACTIONS...
                  </a><br />
                  <span style={{ fontSize: "15px", color: "gray" }}>January 24, 2026</span>
                </h3>
                <p style={{ marginBottom: "0rem" }}>
                  We wish to inform our Esteemed Customers that the Bank of Zambia Currency Directives, 2025, came into effect on 26th December, 2025. The Directives require mandatory use of Zambian Kwacha for all domestic transactions...
                </p>

                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Notice_post_settlement.jpg" target="_blank">
                  <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                  </h5>
                </a>
                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
              </div>
            </div>
          </div>

          <div className="col-xl-4 col-lg-4">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/1226_IZB_tax_noticve-01.jpg" target="_blank">
                <div className="img-holder">
                  <div className="inner">
                    <img className="imgresize" src={customerNotice25} alt="" />

                    <div className="overlay-icon"></div>

                  </div>
                </div>
              </a>

              <div className="text-holder">
                <h3 className="blog-title">

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/1226_IZB_tax_noticve-01.jpg" target="_blank">
                    RENEWAL OF TAX CLEARANCE CERTIFICATE...
                  </a><br />
                  <span style={{ fontSize: "15px", color: "gray" }}>January 22, 2026</span>
                </h3>
                <p style={{ marginBottom: "0rem" }}>
                  Dear Valued Customer, we wish to remind you that all cross-border payments, including Swift and card transactions, that exceed USD2,000.00 or equivalent requires customers to have a valid Tax Clearance Certificate (TCC)...
                </p>

                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/1226_IZB_tax_noticve-01.jpg" target="_blank">
                  <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                  </h5>
                </a>
                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurStores;
